import React from 'react'

const Nouveaute = ( { date, content, systemesActuels, clientelesActuelles, systemesTous, clientelesToutes, locale } ) => {
	const laDate = new Date( date );
	return (
		<article className='nouveaute-complete'>
		<div className='nouveaute-complete-systeme'>
			{ systemesTous.find( ( { id } ) => id === systemesActuels[ 0 ] ).name }
			<span className='nouveaute-sous-titre'><time className='nouveaute-date' dateTime={ date }> / { laDate.toLocaleString( locale, { month: 'long' } ) } { laDate.getFullYear() }</time></span>
		</div>
		<div className='nouveaute-complete-clienteles'>
			{ clientelesActuelles.map( clienteleActuelle => (
				<span className='nouveaute-clientele' key={ clienteleActuelle }>{ clientelesToutes.find( ( { id } ) => id === clienteleActuelle ).name}</span>
			) ) }
			</div>
			<div className='nouveaute-complete-contenu' dangerouslySetInnerHTML={ { __html: content } }></div>
		 </article>
	)
}

export default Nouveaute
